module.exports = "nav {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 999;\n  text-align: center;\n  height: 100px;\n  width: 100%;\n  padding-top: 30px;\n  z-index: 1; }\n  @media screen and (max-width: 1024px) {\n    nav {\n      display: none; } }\n  nav img {\n    max-width: 200px;\n    max-height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/nav/nav.component.scss
// module id = 129
// module chunks = 1